import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'sweetalert2/dist/sweetalert2.css';
import 'sales-flow-ui/utils/lazy-load';
import './tailwind.css';

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMq from 'vue-mq';
import Vue2TouchEvents from 'vue2-touch-events';
import Meta from 'vue-meta';
import MobileDetect from 'mobile-detect';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { sync } from 'vuex-router-sync'

import config from 'config';
import App from './App';
import router from './router';
import store from './store';

import packageJson from '@/../package.json';

const md = new MobileDetect(window.navigator.userAgent);

if (config.RAVEN_URL) {
  Sentry.init({
    dsn: config.RAVEN_URL,
    integrations: [
      new Integrations.Vue({ Vue, attachProps: true }),
      new Sentry.Integrations.GlobalHandlers({
        onerror: true,
        onunhandledrejection: false,
      }),
    ],
    release: packageJson.version,
    environment: process.env.NODE_ENV
  });
}

Vue.use(VueRouter);

let unsync = sync(store, router);

Vue.use(Meta);

Vue.use(VueMq, {
  breakpoints: {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: Infinity,
  },
});

Vue.use(Vue2TouchEvents);

// init
new Vue({
  el: '#body',
  router,
  store,
  render: h => h(App),
  beforeDestroy() {
    unsync();
  },
});

String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

String.prototype.uncapitalize = function() {
  return this.charAt(0).toLowerCase() + this.slice(1);
};

String.prototype.toTitleCase = function() {
  let i, j, str, lowers, uppers;

  str = this.replace(/([^\W_]+[^\s-]*) */g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });

  lowers = ['A', 'An', 'The', 'And', 'But', 'Or', 'For', 'Nor', 'As', 'At', 'By', 'For', 'From', 'In', 'Into', 'Near', 'Of', 'On', 'Onto', 'To', 'With'];
  for (i = 0, j = lowers.length; i < j; i++)
    str = str.replace(new RegExp('\\s' + lowers[i] + '\\s', 'g'),
      function(txt) {
        return txt.toLowerCase();
      });

  uppers = ['Id', 'Tv'];
  for (i = 0, j = uppers.length; i < j; i++)
    str = str.replace(new RegExp('\\b' + uppers[i] + '\\b', 'g'),
      uppers[i].toUpperCase());

  return str;
};

window.addEventListener('unhandledrejection', response => {
  response.preventDefault();

  Sentry.withScope(scope => {
    if (!md.is('bot') && !window.location.search.includes('_escaped_fragment_') && navigator.userAgent.indexOf('HeadlessChrome') === -1) {
      if (!response.reason) {
        if (config.RAVEN_URL) {
          scope.setExtra('response', JSON.stringify(response));

          Sentry.captureException(new Error('Unhandled Rejection: No Reason'));
        } else {
          console.error(response);
        }
      } else if (!response.reason.logged && !response.reason.requiresLogin && ![404, 410].includes(response.reason.status)) {
        if (config.RAVEN_URL) {
          if (response.reason.message) {
            scope.setExtra('response', JSON.stringify(response));

            Sentry.captureException(new Error(`Unhandled Rejection: ${response.reason.message}`));
          } else {
            scope.setExtra('response', JSON.stringify(response));

            Sentry.captureException(new Error('Unhandled Rejection: No Message'));
          }
        } else {
          console.error(response);
        }
      }
    }
  });
});